export default "__VITE_ASSET__Bjgp$uQG__"